"use client"
import React, { useState, useEffect } from "react";
import { emitEvent } from "@/lib/events";
import useApi from "@/components/api/useApi";
import { Modal } from "react-bootstrap";
import EventCalendarLink from "@/components/shared/EventCalendarLink";

const VolunteerLink = ({ name, event }) => {
  const api = useApi();

  const [loaded, setLoaded] = useState(false);
  const [label, setLabel] = useState("Sign Up");
  const [signUp, setSignUp] = useState(true);
  const [signedUp, setSignedUp] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (event && !loaded) {
      // if event has already happened, change label to "Log Hours"
      const now = new Date();
      const eventDate = new Date(event.startDate.date);
      if (now > eventDate) {
        setLabel("Log Activity");
        setSignUp(false);
      }
      setLoaded(true);
    }
  }, [event]);

  const nextStep = () => {
    if (signUp) {
      api.signUpToVolunteerForEvent(name, event.id).then(response => {
        setSignedUp(true);
        setShowModal(true);
      });
    } else {
      emitEvent("log_event_volunteer_hours", event);
    }
  };
  if (loaded) {
    return (
      <>
        {showModal && (
          <Modal centered show={showModal} onHide={evt => setShowModal(false)}>
            <Modal.Header closeButton className="empty"></Modal.Header>
            <Modal.Body>
              <div className={"center-child-div-parent"}>
                <h3>Thanks for signing up to volunteer for this event!</h3>
                <p>Add this event to your calendar so you don't forget.</p>
                <EventCalendarLink event={event} modal={false} />
              </div>
            </Modal.Body>
          </Modal>
        )}
        <button
          type="button"
          className="btn btn-secondary"
          disabled={signedUp}
          onClick={evt => nextStep()}
        >
          {label}
        </button>
      </>
    );
  } else {
    return <></>;
  }
};
export default VolunteerLink;
